<template>
  <el-dialog title="Reservar Imóvel" @open="reset" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      <el-row :gutter="10">
        <el-col :span="20">
          <el-form-item label="Cliente" style="width: 100%">
            <el-select v-model="reserva.cliente"
              :remote-method="recuperarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder=""
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item label="Duração">
            <el-select v-model="reserva.duracao" style="width: 100%">
              <el-option
                v-for="item in duracaoReserva"
                :key="item.data"
                :label="item.label"
                :value="item.data">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="gravar" type="success" size="small">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

import { DURACAO_RESERVA } from '../../util/constantes.js';

import URLS from '../../util/urls.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      loadingClientes: false,
      clientesDisponiveis: [],

      reserva: {
        duracao: 24,
        cliente: { id: 0 }
      }
    }
  },
  computed: {
    ...mapState('imoveisStore', {
      imovel(state) { return state.imovelSelecionado },
    }),
    duracaoReserva() { return DURACAO_RESERVA }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('imoveisStore', [
      'reservarImovel'
    ]),
    reset() {
      this.reserva = {
        duracao: 24,
        cliente: { id: 0 }
      }
      this.clientesDisponiveis = [];
    },
    gravar() {
      let payload = this.reserva;
      payload.imovel = { id: this.imovel.id };

      this.showLoading();
      this.reservarImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    recuperarClientesSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingClientes = true;

      axios.post(URLS.CLIENTES_LISTAR, payload)
      .then((response) => {
        this.clientesDisponiveis = response.data.lista;
        this.loadingClientes = false;
      }).catch(() => {
        this.clientesDisponiveis = [];
        this.loadingClientes = false;
      });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>

